<div class="admin-overlay" [class.show]="show()">
  <ion-segment [value]="activeTab()" (ionChange)="setActiveTab($any($event))">
    @for (tab of tabs; track tab.value) {
      <ion-segment-button [value]="tab.value">
        <ion-label>{{ tab.label | translate }}</ion-label>
      </ion-segment-button>
    }
  </ion-segment>

  <div class="tab-content">
    <ion-list lines="full">
      @if (activeTab() === 'onboarding') {
        <ion-list-header>
          <ion-label>{{ 'Admin.Jump_To_Step' | translate }}</ion-label>
        </ion-list-header>
        @for (stepItem of onboardingSteps(); track stepItem.step) {
          <ion-item button detail (click)="jumpToStep(stepItem.step)">
            <div
              class="step-badge"
              slot="start"
              [class.completed]="stepItem.completed"
              [class.current]="stepItem.current"
            >
              @if (stepItem.completed) {
                <ion-icon name="checkmark-outline"></ion-icon>
              } @else {
                {{ stepItem.position + 1 }}
              }
            </div>
            <ion-label>
              {{ stepItem.label | translate }}
              @if (stepItem.current) {
                <p>{{ 'Admin.Current_Step' | translate }}</p>
              }
            </ion-label>
          </ion-item>
        }
        <ion-list-header>
          <ion-label>{{ 'Admin.Onboarding_Controls' | translate }}</ion-label>
        </ion-list-header>
        <ion-item button detail [disabled]="!group()" (click)="fireNutrientOnboarding()">
          <ion-label>Generate Nutrient Program Onboarding</ion-label>
        </ion-item>
      }
      @for (item of activeSection().items; track item.label) {
        <ion-item
          button
          [disabled]="item.disabled"
          [detail]="item.type === ItemType.Button"
          (click)="item.handler(!item.value)"
        >
          <ion-label>{{ item.label | translate }}</ion-label>
          @switch (item.type) {
            @case (ItemType.Toggle) {
              <ion-toggle slot="end" [checked]="item.value"></ion-toggle>
            }
          }
        </ion-item>
      }
    </ion-list>
  </div>

  <div class="actions">
    <ion-button (click)="close()">
      {{ 'Common.Close' | translate }}
    </ion-button>
  </div>
</div>
<ion-modal
  id="app-state-modal"
  #appStateModal
  class="dialog"
  [isOpen]="showAppState()"
  [attr.aria-label]="'Admin.App_State' | translate"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'Admin.App_State' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="toggleShowAppState(false)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="app-state">
      <pre><code [innerHTML]="appStateString() | jsonHighlight"></code></pre>
    </div>
    <ion-footer>
      <ion-toolbar>
        <ion-button (click)="copyToClipboard(appStateString())">
          <ion-icon name="clipboard-outline"></ion-icon>
          {{ 'Admin.Copy_To_Clipboard' | translate }}
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>

<ion-modal
  id="history-modal"
  #historyModal
  class="dialog"
  [isOpen]="showHistory()"
  [attr.aria-label]="'Admin.History' | translate"
>
  <ng-template>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ 'Admin.History' | translate }}</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="toggleShowHistory(false)">
            <ion-icon slot="icon-only" name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>

    <div class="history">
      @for (item of history(); track item) {
        <div class="item" [class.error]="item.detail.includes('ERROR')">
          <ion-button color="light" size="small" (click)="copyToClipboard(item.detail)">
            <ion-icon
              slot="icon-only"
              [name]="item.type === HistoryType.Navigation ? 'compass-outline' : 'clipboard-outline'"
            ></ion-icon>
          </ion-button>
          <span>
            <pre><code>{{ item.detail }}</code></pre>
          </span>
        </div>
      }
    </div>
    <ion-footer>
      <ion-toolbar>
        <ion-button (click)="copyToClipboard(historyString())">
          <ion-icon name="clipboard-outline"></ion-icon>
          {{ 'Admin.Copy_To_Clipboard' | translate }}
        </ion-button>
      </ion-toolbar>
    </ion-footer>
  </ng-template>
</ion-modal>
